import { trackEvent } from 'dibs-tracking';

type TrackingObject = {
    category: string;
    label: string;
};

const defaultTrackingObj: TrackingObject = {
    category: 'contact dealer',
    label: 'pdp chat box',
};

export const trackInputFocus = (userId?: string | null): void =>
    trackEvent({
        ...defaultTrackingObj,
        action: `contact dealer entry - logged ${userId ? 'in' : 'out|unregistered'}`,
    });

export const trackSendClick = (userId: string | null | undefined): void =>
    trackEvent({
        ...defaultTrackingObj,
        action: `contact dealer send ${userId ? 'clicked' : 'initiated - logged out|unregistered'}`,
    });

export const trackMessageSubmit = (wordCount: number): void =>
    trackEvent({
        ...defaultTrackingObj,
        value: wordCount,
        action: 'contact dealer submitted',
    });

export const trackMinimizeClick = (isMinimized: boolean): void =>
    trackEvent({
        ...defaultTrackingObj,
        action: `pdp chat box ${isMinimized ? 'opened' : 'minimized'}`,
    });

export const trackChatOpen = (isMinimized: boolean): void => {
    trackEvent({
        ...defaultTrackingObj,
        action: 'pdp chat box displayed',
        label: `pdp chat box ${isMinimized ? 'minimized' : 'open'}`,
    });
};
